<script setup>
import CFBanner from '@/ui/Banner/CFBanner.vue';
</script>

<template>
    <CFBanner>
        {{ $t('banner.unverified_team_notice') }}
    </CFBanner>
</template>
